const qrcodeValueModes = require('../pix/qrcodeValueModes');

const qrcodeValueChangeMode = {
  fixed: 0,
  modifiable: 1,
  convertToJDPI(qrcodeValueMode) {
    switch (qrcodeValueMode) {
      case qrcodeValueModes.VALUE_CHANGE_MODE.FIXED_VALUE:
        return this.fixed;
      case qrcodeValueModes.VALUE_CHANGE_MODE.MODIFIABLE:
        return this.modifiable;
      default:
        throw new Error('Invalid QRCode value change mode to convert to JDPI');
    }
  }
};

module.exports = qrcodeValueChangeMode;
